import {createAction, createReducer} from 'redux-act';
import {FULFILLED, PENDING, REJECTED} from 'redux-promise-middleware';
import {ReorderType} from './reorderType';
import {AxiosPromise} from 'axios';
import {HTTP_REQUEST_HEADER} from 'constants/api';
import {ENDPOINTS} from 'constants/endpoints';
import {CHECKOUT} from 'constants/actions';
import {instanceGusaBackend} from 'libs/api';

export const initialState: ReorderType = {
    reorder: null,
    item: null,
    status: '',
};
/**
 * List of actions
 */
export const fetchReorderItem = createAction<AxiosPromise<ReorderType>>(
    'FETCH_REORDER_ITEM',
    (isHomePage = false) =>
        instanceGusaBackend({
            method: 'GET',
            headers: {
                [HTTP_REQUEST_HEADER.AUTHORIZATION]: '',
            },
            url: ENDPOINTS.FETCH_REORDER,
            params: {
                ...(isHomePage ? {useReorderTime: 1} : {}),
            },
        }),
);

/**
 * it triggers analytics from reorder popup if a user logs
 */
export const startWaitAuthResult = createAction('REORDER_SUCCESS_AUTH');

export const setReorderData = createAction<ReorderType>('SET_REORDER_DATA');

/**
 * Fetch reorder item
 */
export const reorder = createReducer<ReorderType>({}, initialState)
    .on(`${fetchReorderItem}_${FULFILLED}`, (state, {data}) => ({
        ...state,
        ...data,
        status: FULFILLED,
    }))
    .on(`${fetchReorderItem}_${PENDING}`, state => ({
        ...state,
        status: PENDING,
    }))
    .on(`${fetchReorderItem}_${REJECTED}`, state => ({
        ...state,
        status: REJECTED,
    }))
    .on(`${setReorderData}`, (state, data: ReorderType) => data)
    .on(`${CHECKOUT.SAVE_ORDER}_FULFILLED`, () => initialState);
